// Image URLs
const BGM_IMAGES = {
  loose: 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/Loose_Gemstone_b2856d8c-3e38-432d-a266-4b2f82226dc1.webp?v=1766991622',
  ring: 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/Ring.png?v=1766991622',
  pendant: 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/Pendant.webp?v=1766991622',
  metals: {
    copper: 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/520191618904734.png?v=1766989548',
    silver: 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/321941618317198.png?v=1766989670',
    'panchdhatu-mix-of-five-metals': 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/759601619676475.jpg?v=1766989670',
    '18k-yellow-gold': 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/026371618317258.png?v=1766989670',
    '18k-white-gold': 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/643811618210144.png?v=1766989670',
    '22k-yellow-gold': 'https://cdn.shopify.com/s/files/1/0820/2869/1736/files/026371618317258.png?v=1766989670',
  }
};

// Ring sizes based on system
const RING_SIZES = {
  indian: ['6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20','21','22','23','24','25','26','27','28','29','30'],
  us: ['4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11'],
  uk: ['F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T']
};

// State management
let bgmState = {
  buyingOption: 'loose',
  metal: 'silver',
  design: null,
  ringSystem: 'indian',
  ringSize: '',
  chainRequired: false
};

async function showDisclaimer() {
  const disclaimerBox = document.querySelector('.bmg-disclaimer-box');

  if (!disclaimerBox) return;

  disclaimerBox.innerHTML = '';
  disclaimerBox.style.display = 'none';

  if (bgmState.buyingOption === "loose") return;

  // Metal data mapping
  const metalData = {
    "copper": { price: 2500, pandant_price: 2000, making_charges: 0, per_gram: false, metal: "Copper" },
    "silver": { price: 3000, pandant_price: 2500, making_charges: 0, per_gram: false, metal: "Silver" },
    "panchdhatu-mix-of-five-metals": { price: 2500, pandant_price: 2000, making_charges: 0, per_gram: false, metal: "Panchdhatu (Mix of five Metals)" },
    "22k-yellow-gold": { price: 21000, pandant_price: 21000, making_charges: 0, per_gram: false, metal: "22k Yellow Gold" },
    "18k-white-gold": { price: 21000, pandant_price: 21000, making_charges: 0, per_gram: false, metal: "18k White Gold" },
    "18k-yellow-gold": { price: 21000, pandant_price: 21000, making_charges: 0, per_gram: false, metal: "18k Yellow Gold" }
  };

  const metalType = bgmState.metal;
  if (!metalData[metalType]) return;

  const metal = metalData[metalType];
  const metalName = metal.metal;
  const isPendant = bgmState.buyingOption === "pendant";
  const jewelryType = isPendant ? 'Pendant' : 'Ring';
  const metalPrice = isPendant ? metal.pandant_price : metal.price;

  const isGold = ['18k-yellow-gold', '18k-white-gold', '22k-yellow-gold'].includes(metalType);

  let disclaimerText = '';

  if (isGold) {
    let makingChargesText = 'and making charges';

    if (metal.making_charges > 0) {
      makingChargesText = metal.per_gram
        ? `and making charges of ₹${metal.making_charges.toLocaleString('en-IN')} per gram`
        : `and making charges of ₹${metal.making_charges.toLocaleString('en-IN')}`;
    }

    disclaimerText = `
            An advance of <span class="bgm-text-orange">
            ₹${metalPrice.toLocaleString('en-IN')}
            </span> is required to place an order for a
            ${metalName} ${jewelryType}. The final price will be calculated
            based on the prevailing gold rate, final weight,
            ${makingChargesText}.
            Our executive will contact you to share complete pricing details
            before final confirmation.
        `;
  } else {
    disclaimerText = `
            An additional <span class="bgm-text-orange">
            ₹${metalPrice.toLocaleString('en-IN')}
            </span> will be charged for a
            ${metalName} ${jewelryType}. This amount includes metal and making charges.
        `;
  }

  disclaimerBox.innerHTML = `
        <strong class="bgm-disclaimer-label">Disclaimer:</strong>
        <span class="bgm-disclaimer-text">${disclaimerText}</span>
    `;

  disclaimerBox.style.display = 'block';
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
  initializeApp();
});

function initializeApp() {
  // Preselect "Buy Loose Gemstone" on load
  selectBuyingOption('loose');

  // Set up event listeners
  setupBuyingOptionListeners();
  setupMetalListeners();
  setupDesignListeners();
  setupSizeListeners();

  // Don't load product for loose gemstone on initial load
  // Product will be loaded when user selects ring or pendant
}

// Buying Option Handlers
function setupBuyingOptionListeners() {
  const options = document.querySelectorAll('.bgm-option');
  options.forEach(option => {
    option.addEventListener('click', function () {
      const optionType = this.dataset.option;
      selectBuyingOption(optionType);
    });
  });
}

// Function to update Shopify product submit button
// function updateProductSubmitButton(optionType) {
//   // Try to find the button by ID pattern or class
//   const productSubmitButton = document.querySelector('[id*="ProductSubmitButton"], .product-form__submit, button[type="submit"][name="add"]');

//   if (productSubmitButton) {
//     const buttonSpan = productSubmitButton.querySelector('span');

//     if (optionType === 'loose') {
//       // For loose gemstone: keep as submit button
//       productSubmitButton.type = 'submit';
//       if (buttonSpan) {
//         buttonSpan.textContent = 'Add to cart';
//       } else {
//         productSubmitButton.textContent = 'Add to cart';
//       }
//     } else if (optionType === 'ring' || optionType === 'pendant') {
//       // For ring or pendant: change to button type
//       productSubmitButton.type = 'button';

//       const optionTypeCapitalized = optionType.charAt(0).toUpperCase() + optionType.slice(1);
//       if (buttonSpan) {
//         buttonSpan.textContent = `Buy Loose Gemstone + ${optionTypeCapitalized}`;
//       } else {
//         productSubmitButton.textContent = `Buy Loose Gemstone + ${optionTypeCapitalized}`;
//       }

//       // Remove existing submit handler and add our custom handler
//       productSubmitButton.removeEventListener('click', handleProductSubmitButtonClick);
//       productSubmitButton.addEventListener('click', handleProductSubmitButtonClick);
//     }
//   }
// }
function updateProductSubmitButton(optionType) {
  // Try to find the button by ID pattern or class
  const productSubmitButton = document.querySelector('[id*="ProductSubmitButton"], .product-form__submit, button[type="submit"][name="add"]');

  if (productSubmitButton) {
    // ✅ Agar product sold out hai (button already disabled), text overwrite mat karo
    if (productSubmitButton.disabled) {
      return;
    }

    const buttonSpan = productSubmitButton.querySelector('span');

    if (optionType === 'loose') {
      // For loose gemstone: keep as submit button
      productSubmitButton.type = 'submit';
      if (buttonSpan) {
        buttonSpan.textContent = 'Add to cart';
      } else {
        productSubmitButton.textContent = 'Add to cart';
      }
    } else if (optionType === 'ring' || optionType === 'pendant') {
      // For ring or pendant: change to button type
      productSubmitButton.type = 'button';

      const optionTypeCapitalized = optionType.charAt(0).toUpperCase() + optionType.slice(1);
      if (buttonSpan) {
        buttonSpan.textContent = `Buy Loose Gemstone + ${optionTypeCapitalized}`;
      } else {
        productSubmitButton.textContent = `Buy Loose Gemstone + ${optionTypeCapitalized}`;
      }

      // Remove existing submit handler and add our custom handler
      productSubmitButton.removeEventListener('click', handleProductSubmitButtonClick);
      productSubmitButton.addEventListener('click', handleProductSubmitButtonClick);
    }
  }
}
// Handler for the product submit button when it's type="button"
function handleProductSubmitButtonClick(e) {
  if (bgmState.buyingOption === 'ring' || bgmState.buyingOption === 'pendant') {
    e.preventDefault();
    e.stopPropagation();
    handleAddToCart();
  }
}

async function selectBuyingOption(optionType) {
  // Update state
  bgmState.buyingOption = optionType;
  bgmState.design = null;

  // Update UI - active option
  document.querySelectorAll('.bgm-option').forEach(opt => {
    opt.classList.remove('bgm-option-active');
  });
  const activeOption = document.querySelector(`[data-option="${optionType}"]`);
  if (activeOption) {
    activeOption.classList.add('bgm-option-active');
  }

  // Update Shopify product submit button
  updateProductSubmitButton(optionType);

  // Get section elements
  const additionalOptions = document.getElementById('bgm-additional-options');
  const sizeSection = document.getElementById('bgm-size-section');
  const designsContainer = document.getElementById('bgm-designs');
  const metalSection = document.getElementById('bgm-metal-section');
  const designSection = document.querySelector('.bgm-design-section');

  // Get Add to Cart button
  const addToCartButton = document.getElementById('bgm-buy-now-button');

  if (optionType === 'loose') {
    // Hide all sections for loose gemstone
    if (additionalOptions) additionalOptions.style.display = 'none';
    if (sizeSection) sizeSection.style.display = 'none';
    if (designsContainer) designsContainer.style.display = 'none';
    if (metalSection) metalSection.style.display = 'none';
    if (designSection) designSection.style.display = 'none';
    if (addToCartButton) addToCartButton.style.display = 'none';
  } else if (optionType === 'ring') {
    // Show relevant sections for ring
    if (additionalOptions) additionalOptions.style.display = 'none';
    if (sizeSection) sizeSection.style.display = 'block';
    if (designsContainer) designsContainer.style.display = 'grid';
    if (metalSection) metalSection.style.display = 'block';
    if (designSection) designSection.style.display = 'block';
    if (addToCartButton) addToCartButton.style.display = 'block';

    // Load designs from Shopify API if available
    await loadDesignsFromShopify(optionType, designsContainer);
  } else if (optionType === 'pendant') {
    // Show relevant sections for pendant
    if (additionalOptions) additionalOptions.style.display = 'flex';
    if (sizeSection) sizeSection.style.display = 'none';
    if (designsContainer) designsContainer.style.display = 'grid';
    if (metalSection) metalSection.style.display = 'block';
    if (designSection) designSection.style.display = 'block';
    if (addToCartButton) addToCartButton.style.display = 'block';

    // Load designs from Shopify API if available
    await loadDesignsFromShopify(optionType, designsContainer);
  }

  // Reset design selection
  document.querySelectorAll('.bgm-design-item').forEach(item => {
    item.classList.remove('bgm-design-active');
  });

  // Show disclaimer when buying option changes
  await showDisclaimer();
}

function bgmExtractNumericId(shopifyGid) {
  if (!shopifyGid) return null;
  const m = String(shopifyGid).match(/(\d+)\s*$/);
  return m ? m[1] : null;
}

async function bgmFetchAllProductsByTagFromStorefront(tag) {
  const token = "d4627a2a0aa9d87efc9860d3ee19ec1e";
  if (!token) throw new Error('Missing STOREFRONT_TOKEN');

  const endpoint = `https://thenaturalgemstone.com/api/2025-01/graphql.json`;

  const query = `
    query ProductsSearch($after: String, $q: String!) {
      products(first: 50, after: $after, query: $q) {
        pageInfo { hasNextPage endCursor }
        nodes {
          id
          title
          tags
          handle
          featuredImage { url }
          images(first: 10) { nodes { url } }
          variants(first: 100) {
            nodes {
              id
              sku
              title
              availableForSale
              image { url }
            }
          }
        }
      }
    }
  `;

  // 🔥 Break slug into keywords for better matching
  const keywords = tag.split('-').filter(Boolean);

  // Example:
  // jewellery-ring-yellow-sapphire-pukhraj
  // → "jewellery AND ring AND yellow AND sapphire AND pukhraj"
  const searchQuery = keywords.join(' AND ');

  let after = null;
  const all = [];

  while (true) {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({
        query,
        variables: { after, q: searchQuery },
      }),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Storefront API error ${res.status}: ${text}`);
    }

    const json = await res.json();

    if (json.errors?.length) {
      console.error(json.errors);
      throw new Error(`GraphQL errors`);
    }

    const block = json?.data?.products;
    const nodes = block?.nodes || [];

    for (const p of nodes) {
      const productTags = (p.tags || []).map(t => t.toLowerCase());

      // ✅ Exact match OR partial match (flexible)
      const isExactMatch = productTags.includes(tag.toLowerCase());

      const isKeywordMatch = keywords.some(k =>
        productTags.some(t => t.includes(k))
      );

      if (isExactMatch || isKeywordMatch) {
        all.push(p);
      }
    }

    if (!block?.pageInfo?.hasNextPage) break;
    after = block.pageInfo.endCursor;
  }

  return all;
}

// Function to load designs from Shopify API
async function loadDesignsFromShopify(optionType, container) {
  if (!container) return;

  // Show skeleton loaders
  const skeletonItems = container.querySelectorAll('[data-skeleton="true"]');
  skeletonItems.forEach(item => {
    item.style.display = '';
  });

  // Clear any existing design items (but keep skeleton visible)
  const existingItems = container.querySelectorAll('.bgm-design-item:not(.bgm-skeleton-item)');
  existingItems.forEach(item => item.remove());

  try {
    // Build tags based on your ManageProductJob.php structure
    // Tags format: "Jewellery, Ring/Pendant, GemstoneType"
    const gemstoneType = window.currentGemstoneType || 'Yellow Sapphire (Pukhraj)'; // Fallback to yellow-sapphire
    const jewelryType = optionType === 'ring' ? 'Ring' : 'Pendant';

    // Match the tags format from your PHP: "Jewellery-Ring-gemstone-type"
    const tags = `Jewellery-${jewelryType}-${gemstoneType.replaceAll(' ', '-')}`.toString()
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/[\s\W-]+/g, '-')
      .replace(/^-+|-+$/g, '');

    let products = [];
    try {
      products = await bgmFetchAllProductsByTagFromStorefront(tags);
    } catch (e) {
      console.warn('Storefront API failed, falling back to products.json', e);
      const apiUrl = `https://thenaturalgemstone.myshopify.com/products.json?tags=${encodeURIComponent(tags)}`;
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error('Failed to load designs from Shopify products.json');
      const data = await response.json();
      products = data.products || data || [];
      // Exact match filter (products.json sometimes returns partial matches)
      products = products.filter(p => {
        const ptags = p.tags || [];
        if (Array.isArray(ptags)) return ptags.includes(tags);
        return String(ptags).split(',').map(t => t.trim()).includes(tags);
      });
    }

    // Hide skeleton loaders
    skeletonItems.forEach(item => {
      item.style.display = 'none';
    });

    if (products.length > 0) {
      // Clear skeleton and add real design items
      container.innerHTML = '';

      // Process all products and their variants
      products.forEach(product => {
        const productVariants = product.variants?.nodes || product.variants || [];
        const productImages = product.images?.nodes || product.images || [];
        const productFeaturedImage = product.featuredImage?.url || product.images?.nodes?.[0]?.url || product.images?.[0]?.src || '';

        productVariants.forEach(variant => {
          const designItem = document.createElement('div');
          designItem.classList.add('bgm-design-item');
          const variantId = bgmExtractNumericId(variant.id) || variant.id;
          designItem.dataset.design = variantId;

          // Get variant image or fallback to product image
          const imageUrl =
            variant.image?.url ||
            variant.image ||
            productImages[0]?.url ||
            productImages[0]?.src ||
            productFeaturedImage ||
            '';

          // Create proper HTML structure matching the existing design items
          designItem.innerHTML = `
            <div class="bgm-design-image">
              <img src="${imageUrl}" alt="${product.title}">
            </div>
            <div class="bgm-design-code">${product.title || variant.sku || variantId}</div>
          `;

          container.appendChild(designItem);
        });
      });

      // Event listeners are handled via event delegation, so no need to re-attach
    } else {
      // No products found - keep skeleton hidden
      skeletonItems.forEach(item => {
        item.style.display = 'none';
      });
    }
  } catch (error) {
    console.error('Error loading designs from Shopify:', error);
    // Hide skeleton on error
    skeletonItems.forEach(item => {
      item.style.display = 'none';
    });
    // Silently fail - skeleton will be hidden
  }
}

// Metal Selection Handlers
function setupMetalListeners() {
  const metals = document.querySelectorAll('.bgm-metal-option');
  metals.forEach(metal => {
    metal.addEventListener('click', function () {
      const metalType = this.dataset.metal;
      selectMetal(metalType);
    });
  });
}

async function selectMetal(metalType) {
  // Update state
  bgmState.metal = metalType;

  // Update UI
  document.querySelectorAll('.bgm-metal-option').forEach(metal => {
    metal.classList.remove('bgm-metal-active');
  });
  const activeMetal = document.querySelector(`[data-metal="${metalType}"]`);
  if (activeMetal) {
    activeMetal.classList.add('bgm-metal-active');
  }

  // Reload designs if ring or pendant is selected (not loose)
  if (bgmState.buyingOption !== 'loose') {
    const designsContainer = document.getElementById('bgm-designs');
    if (designsContainer && designsContainer.style.display !== 'none') {
      await loadDesignsFromShopify(bgmState.buyingOption, designsContainer);

      // Reset design selection when metal changes
      document.querySelectorAll('.bgm-design-item').forEach(item => {
        item.classList.remove('bgm-design-active');
      });
      bgmState.design = null;
    }
  }

  // Show disclaimer when metal changes
  await showDisclaimer();
}

// Design Selection Handlers - Use event delegation for dynamic content
function setupDesignListeners() {
  // Use event delegation on the designs container
  const designsContainer = document.getElementById('bgm-designs');
  if (designsContainer) {
    // Remove existing listener if any
    designsContainer.removeEventListener('click', handleDesignClick);
    // Add event listener with event delegation
    designsContainer.addEventListener('click', handleDesignClick);
  }
}

function handleDesignClick(e) {
  // Find the clicked design item (could be the item itself or a child element)
  const designItem = e.target.closest('.bgm-design-item');
  if (designItem) {
    const designCode = designItem.dataset.design;
    selectDesign(designCode);
  }
}

function selectDesign(designCode) {
  // Update state
  bgmState.design = designCode;

  // Update UI - highlight the selected design
  const designsContainer = document.getElementById('bgm-designs');

  if (designsContainer) {
    // Remove active class from all design items
    designsContainer.querySelectorAll('.bgm-design-item').forEach(item => {
      item.classList.remove('bgm-design-active');
    });

    // Add active class to the selected design item
    const selectedItem = designsContainer.querySelector(`[data-design="${designCode}"]`);
    if (selectedItem) {
      selectedItem.classList.add('bgm-design-active');
    }
  }

}

// Size Selection Handlers
function setupSizeListeners() {
  const ringSystem = document.getElementById('bgm-ring-system');
  const ringSize = document.getElementById('bgm-ring-size');
  const chainSelect = document.getElementById('bgm-chain-select');

  if (ringSystem) {
    ringSystem.addEventListener('change', function () {
      bgmState.ringSystem = this.value;
      updateRingSizes();
    });
  }

  if (ringSize) {
    ringSize.addEventListener('change', function () {
      bgmState.ringSize = this.value;
    });
  }

  if (chainSelect) {
    chainSelect.addEventListener('change', function () {
      bgmState.chainRequired = this.value === 'required';
    });
  }

  // Initialize ring sizes
  updateRingSizes();
}

function updateRingSizes() {
  const ringSizeSelect = document.getElementById('bgm-ring-size');
  if (!ringSizeSelect) return;

  const sizes = RING_SIZES[bgmState.ringSystem] || RING_SIZES.indian;
  ringSizeSelect.innerHTML = '<option value="">-- Select Ring Size --</option>';

  sizes.forEach(size => {
    const option = document.createElement('option');
    option.value = size;
    option.textContent = size;
    ringSizeSelect.appendChild(option);
  });

  bgmState.ringSize = '';
}

// Add to Cart Handler
function setupAddToCartButton() {
  const addToCartButton = document.getElementById('bgm-buy-now-button');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', handleAddToCart);
  }
}

async function handleAddToCart() {
  // Validate selections
  if (bgmState.buyingOption === 'loose') {
    alert('Please select Ring or Pendant to add to cart.');
    return;
  }

  if (!bgmState.design) {
    alert('Please select a design.');
    return;
  }

  // For rings, validate size
  if (bgmState.buyingOption === 'ring' && !bgmState.ringSize) {
    alert('Please select a ring size.');
    return;
  }

  try {
    // Build properties object for the cart item
    const properties = {};

    // Add metal property
    const metalNames = {
      'copper': 'Copper',
      'silver': 'Silver',
      'panchdhatu-mix-of-five-metals': 'Panchdhatu (Mix of five Metals)',
      '18k-white-gold': '18k White Gold',
      '18k-yellow-gold': '18k Yellow Gold',
      '22k-yellow-gold': '22k Yellow Gold',
    };
    properties['Metal'] = metalNames[bgmState.metal] || bgmState.metal;

    // Add ring system and size for rings
    if (bgmState.buyingOption === 'ring') {
      properties['Ring System'] = bgmState.ringSystem.charAt(0).toUpperCase() + bgmState.ringSystem.slice(1);
      properties['Ring Size'] = bgmState.ringSize;
    }

    // Add chain option for pendants
    if (bgmState.buyingOption === 'pendant') {
      properties['Silver Chain'] = bgmState.chainRequired ? 'Required' : 'Not Required';
    }

    // Get the main product variant ID from the form
    const mainProductVariantId = document.querySelector('input[name="id"], input.product-variant-id')?.value;

    if (!mainProductVariantId) {
      throw new Error('Main product variant ID not found. Please refresh the page and try again.');
    }

    // Add both jewelry product and main product to cart in a single API call
    // Shopify Cart API expects properties as an object (hash), not an array
    const jewelryVariantId = bgmState.design; // This is the variant ID from the design selection

    const cartData = {
      items: [
        // Add jewelry product (ring/pendant) with properties
        {
          id: jewelryVariantId,
          quantity: 1,
          properties: properties
        },
        // Add main product (loose gemstone)
        {
          id: mainProductVariantId,
          quantity: 1
        }
      ]
    };

    // Use Shopify Cart API to add both items at once
    let response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData)
    });

    let cartResult;
    let addedItemsCount = 0; // Track how many items were successfully added

    // If batch add fails, try adding items individually
    if (!response.ok) {
      const errorData = await response.json();

      // If 422 error (item already in cart), try adding items individually
      if (response.status === 422 && errorData.message && errorData.message.includes('already in your cart')) {
        console.warn('Batch add failed, trying individual adds:', errorData.message);

        const addedItems = [];
        const errors = [];

        // Try adding jewelry product first
        try {
          const jewelryResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: jewelryVariantId,
                quantity: 1,
                properties: properties
              }]
            })
          });

          if (jewelryResponse.ok) {
            const jewelryResult = await jewelryResponse.json();
            addedItems.push('jewelry');
            addedItemsCount++;
            cartResult = jewelryResult;
          } else {
            const jewelryError = await jewelryResponse.json();
            errors.push(`Jewelry: ${jewelryError.description || jewelryError.message || 'Failed to add'}`);
          }
        } catch (err) {
          errors.push(`Jewelry: ${err.message}`);
        }

        // Try adding main product
        try {
          const mainResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: mainProductVariantId,
                quantity: 1
              }]
            })
          }).then(() => {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
          }).catch((error) => console.error(error));

          if (mainResponse.ok) {
            const mainResult = await mainResponse.json();
            if (!cartResult) {
              cartResult = mainResult;
            } else {
              // Merge item counts if both succeeded
              cartResult.items = [...(cartResult.items || []), ...(mainResult.items || [])];
              cartResult.item_count = (cartResult.item_count || 0) + (mainResult.item_count || 0);
            }
            addedItems.push('main product');
            addedItemsCount++;
          } else {
            const mainError = await mainResponse.json();
            errors.push(`Main product: ${mainError.description || mainError.message || 'Failed to add'}`);
          }
        } catch (err) {
          errors.push(`Main product: ${err.message}`);
        }

        // If both failed, show error message
        if (addedItems.length === 0) {
          // Both items already in cart or failed
          const productSubmitButton = document.querySelector('[id*="ProductSubmitButton"], .product-form__submit, button[type="submit"][name="add"], button[type="button"][name="add"]');
          if (productSubmitButton) {
            const buttonSpan = productSubmitButton.querySelector('span');
            const errorMsg = 'Items already in cart';
            if (buttonSpan) {
              buttonSpan.textContent = errorMsg;
            } else {
              productSubmitButton.textContent = errorMsg;
            }

            // Reset button text after 3 seconds
            setTimeout(() => {
              const currentOption = bgmState.buyingOption;
              const optionTypeCapitalized = currentOption === 'loose' ? '' : currentOption.charAt(0).toUpperCase() + currentOption.slice(1);
              if (buttonSpan) {
                buttonSpan.textContent = currentOption === 'loose' ? 'Add to Cart' : `Buy Loose Gemstone + ${optionTypeCapitalized}`;
              } else {
                productSubmitButton.textContent = currentOption === 'loose' ? 'Add to Cart' : `Buy Loose Gemstone + ${optionTypeCapitalized}`;
              }
            }, 3000);
          }

          // Trigger cart drawer to show existing items
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.open();
          }

          if (window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('cart:updated'));
          }

          return; // Exit function without throwing error
        }

        // If at least one succeeded, show success but note if some items were already in cart
        if (errors.length > 0) {
          console.warn('Some items may already be in cart:', errors);
          // Still proceed to show success message below
        }
      } else {
        // For other errors, throw normally
        throw new Error(errorData.description || errorData.message || 'Failed to add item to cart');
      }
    } else {
      // Batch add succeeded
      cartResult = await response.json();
      addedItemsCount = 2; // Both items added successfully
    }

    // Update button text to show success message
    const productSubmitButton = document.querySelector('[id*="ProductSubmitButton"], .product-form__submit, button[type="submit"][name="add"], button[type="button"][name="add"]');
    if (productSubmitButton) {
      const buttonSpan = productSubmitButton.querySelector('span');
      // Get item count from response (may vary based on API response format)
      const itemCount = cartResult.item_count || cartResult.items?.length || addedItemsCount || 2;
      const successMsg = `${itemCount} item${itemCount > 1 ? 's' : ''} added to cart successfully!`;

      if (buttonSpan) {
        buttonSpan.textContent = successMsg;
      } else {
        productSubmitButton.textContent = successMsg;
      }

      // Reset button text after 3 seconds
      setTimeout(() => {
        const currentOption = bgmState.buyingOption;
        const optionTypeCapitalized = currentOption === 'loose' ? '' : currentOption.charAt(0).toUpperCase() + currentOption.slice(1);
        if (buttonSpan) {
          buttonSpan.textContent = currentOption === 'loose' ? 'Add to Cart' : `Buy Loose Gemstone + ${optionTypeCapitalized}`;
        } else {
          productSubmitButton.textContent = currentOption === 'loose' ? 'Add to Cart' : `Buy Loose Gemstone + ${optionTypeCapitalized}`;
        }

      }, 3000);
    }
    await refreshAndOpenCartDrawer();

    // Show success message
    // alert('Item added to cart successfully!');

    // Optionally trigger cart drawer/notification if available
    if (window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('cart:updated'));
    }

    // Optionally redirect to cart page
    // window.location.href = '/cart';

  } catch (error) {
    console.error('Error adding to cart:', error);
    alert('Failed to add item to cart. Please try again.');
  }
}

async function refreshAndOpenCartDrawer() {
  try {
    window.location.href = '/cart';
    // // 1. Fetch latest cart
    // const cart = await fetch('/cart.js').then(r => r.json());

    // // 2. Notify theme
    // document.dispatchEvent(new CustomEvent('cart:updated', {
    //   detail: { cart }
    // }));

    // // 3. Open drawer
    // const drawer = document.querySelector('cart-drawer');
    // if (drawer) drawer.open();

  } catch (err) {
    console.error('Cart refresh failed', err);
  }
}


// Modal Handler
document.addEventListener('DOMContentLoaded', function () {
  // Setup Add to Cart button
  setupAddToCartButton();

  // Initialize product submit button on page load
  updateProductSubmitButton(bgmState.buyingOption);

  const sizingGuide = document.getElementById('bgm-sizing-guide');
  const modal = document.getElementById('bgm-sizing-modal');
  const modalClose = document.getElementById('bgm-modal-close');
  const modalOverlay = modal ? modal.querySelector('.bgm-modal-overlay') : null;

  // Open modal
  if (sizingGuide && modal) {
    sizingGuide.addEventListener('click', function (e) {
      e.preventDefault();
      modal.classList.add('bgm-modal-active');
      document.body.style.overflow = 'hidden'; // Prevent body scroll
    });
  }

  // Close modal
  function closeModal() {
    if (modal) {
      modal.classList.remove('bgm-modal-active');
      document.body.style.overflow = ''; // Restore body scroll
    }
  }

  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  if (modalOverlay) {
    modalOverlay.addEventListener('click', closeModal);
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('bgm-modal-active')) {
      closeModal();
    }
  });
});

